import { useColorScheme } from '@mui/material';
import { RiDashboardHorizontalFill } from 'react-icons/ri';
import { TbLayoutSidebarRightCollapseFilled } from 'react-icons/tb';
import { TbLayoutSidebarLeftCollapseFilled } from 'react-icons/tb';
import classNames from 'classnames';
import { Link, useLocation, useNavigate } from '@tanstack/react-router';
import { FaCircleInfo, FaServer } from 'react-icons/fa6';
import { MdCalculate, MdSettings } from 'react-icons/md';
import { motion } from 'motion/react';
import { useEffect, useMemo } from 'react';
import router from '@configs/router';

export interface menuItem {
  name: string;
  icon: Element | any;
  action?: (...args) => (void | unknown) | unknown;
  position: 'bottom' | 'top';
  route?: string;
}
const SideNav = ({
  open = false,
  setOpen,
}: {
  open: boolean;
  setOpen: (_value: boolean) => void;
}) => {
  const { mode, systemMode } = useColorScheme();
  const location = useLocation();

  const menuItems: menuItem[] = [
    {
      name: 'Home',
      icon: RiDashboardHorizontalFill,
      route: '/home',
      position: 'top',
    },
    {
      name: 'Nodes',
      icon: FaServer,
      route: '/nodes',
      position: 'top',
    },
    // {
    //   name: 'Help',
    //   icon: FaCircleInfo,
    //   route: '/help',
    //   position: 'bottom',
    // },
    {
      name: 'Close',
      icon: open
        ? TbLayoutSidebarLeftCollapseFilled
        : TbLayoutSidebarRightCollapseFilled,
      action: () => setOpen(!open),
      position: 'bottom',
    },
  ];

  const goToRoute = (route: any) => router.navigate({ to: route });

  return (
    <div className="w-full h-full grid grid-rows-[auto_auto_1fr_auto_auto] content-start justify-start">
      {menuItems.map((item, index) => {
        let isCurrentRoute = location?.pathname.includes(item.route!);
        return (
          <div
            id={`item-${item.name}`}
            className={
              ' h-auto flex items-center justify-start gap-2 py-2 px-3 text-base rounded-lg no-select cursor-pointer ' +
              classNames({
                'self-end ': item.position === 'bottom',
                'self-start': item.position === 'top',
                'mb-4': index !== menuItems.length - 1,
                'w-[150px]': open,
                'hover:bg-gray-900 ':
                  open &&
                  (mode === 'dark' ||
                    (mode === 'system' && systemMode === 'dark')),
                'hover:bg-gray-100':
                  open &&
                  (mode === 'light' ||
                    (mode === 'system' && systemMode === 'light')),
                'w-auto': !open,
                'hover:text-gray-400 text-gray-800':
                  mode === 'light' ||
                  (mode === 'system' && systemMode === 'light'),
                'hover:text-gray-200 text-gray-400':
                  mode === 'dark' ||
                  (mode === 'system' && systemMode === 'dark'),
                'text-gray-400 ':
                  mode === 'light' ||
                  (mode === 'system' && systemMode === 'light'),
                'text-gray-200 ':
                  mode === 'dark' ||
                  (mode === 'system' && systemMode === 'dark'),
                '!text-primary': isCurrentRoute,
              })
            }
            onClick={() => {
              if (item.route) goToRoute(item.route);
              if (item.action) item.action();
            }}
          >
            <span className="h-[25px] w-auto aspect-square flex items-center">
              <item.icon size="100%" />
            </span>
            {open && (
              <motion.p
                animate={{
                  opacity: [0, 1],
                  y: [5, 0],
                  scale: [0.8, 1],
                }}
              >
                {item.name}
              </motion.p>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default SideNav;
